import { IconButton, TooltipV2, Typography } from '@getgo/chameleon-web/react';
import { LinkHorizontalIcon } from '@getgo/chameleon-icons/react';
import React, { FC } from 'react';
import copy from 'copy-to-clipboard';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useTranslation } from 'react-i18next';
import { onCopyOfEventLinkTracker } from '../../../mixpanel/Feature/copyLinkTracker';

export interface EventCopyLinkProps {
  title: string;
  eventKey?: string;
}

export const EventCopyLink: FC<EventCopyLinkProps> = ({ title, eventKey }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const copyEventLink = () => {
    const copyLink = location.href;
    copy(copyLink);
    onCopyOfEventLinkTracker({ description: 'Copy Event Link', copyLink, eventKey });
  };
  return (
    <>
      <div className="event-title-box">
        <Typography variant="heading-large" tag="h1">
          {title}
        </Typography>
        <TooltipV2
          position={(width <= 950 ? 'top-center' : 'right-center') as any}
          trigger={
            <IconButton
              id="EventCopyLink"
              className="event-title-copy-to-icon"
              onClick={copyEventLink}
              size="xsmall"
              variant="secondary"
            >
              <LinkHorizontalIcon className="bottom-anchor" />
            </IconButton>
          }
        >
          <span>{t('event.copyEventLink')}</span>
        </TooltipV2>
      </div>
    </>
  );
};
